import themeFactory from '../helpers/themeFactory';

export default themeFactory({
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  color: 'inherit',
  textDecoration: 'underline'
});
